import script from "./captionContrast.vue?vue&type=script&setup=true&lang=ts"
export * from "./captionContrast.vue?vue&type=script&setup=true&lang=ts"

import "./captionContrast.vue?vue&type=style&index=0&id=5b1e947f&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1e947f"]])

export default __exports__